module.exports = __webpack_public_path__ + "7b667e1704a0e105040a152946a52319.svg";